import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import type { RootState } from '../app/store';
import { User } from 'types/data/user.t';
import { SupportedLanguage } from 'config';

// Define a type for the slice state
interface CurrentUserState {
  value: User;
}

// Define the initial state using that type
const initialState: CurrentUserState = {
  value: {
    id: 0,
    email: '',
    firstname: '',
    lastname: '',
    avatar: null,
    phone: null,
    address: null,
    showPhone: true,
    language: SupportedLanguage.en,
    theme: 'auto',
    role: null,
    workspaceId: null,
    workspace: null,
    createdAt: '',
    updatedAt: '',
    deletedAt: null
  }
};

export const currentUserSlice = createSlice({
  name: 'currentUser',
  // `createSlice` will infer the state type from the `initialState` argument
  initialState,
  reducers: {
    updateCurrentUser: (state, action: PayloadAction<User>) => {
      state.value = action.payload;
    }
  }
});

export const { updateCurrentUser } = currentUserSlice.actions;

// Other code such as selectors can use the imported `RootState` type
export const selectCurrentUser = (state: RootState) => state.currentUser.value;

export default currentUserSlice.reducer;
